(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode(".fade-enter-active[data-v-6d9f3f05],.fade-leave-active[data-v-6d9f3f05]{transition:opacity .3s ease}.fade-enter[data-v-6d9f3f05],.fade-leave-to[data-v-6d9f3f05]{opacity:0}.linked-icons[data-v-6d9f3f05]{display:flex}.linked-icons img[data-v-6d9f3f05]{padding:12px;height:44px;display:block;background-repeat:no-repeat;background-position:center;opacity:.7}.linked-icons img[data-v-6d9f3f05]:hover{opacity:1}.popovermenu[data-v-6d9f3f05]{display:none}.popovermenu.open[data-v-6d9f3f05]{display:block}li.collection-list-item[data-v-6d9f3f05]{flex-wrap:wrap;height:auto;cursor:pointer;margin-bottom:0!important}li.collection-list-item .collection-avatar[data-v-6d9f3f05]{margin-top:6px}li.collection-list-item form[data-v-6d9f3f05],li.collection-list-item .collection-item-name[data-v-6d9f3f05]{flex-basis:10%;flex-grow:1;display:flex}li.collection-list-item .collection-item-name[data-v-6d9f3f05]{padding:12px 9px}li.collection-list-item input[type=text][data-v-6d9f3f05]{margin-top:4px;flex-grow:1}li.collection-list-item .error[data-v-6d9f3f05],li.collection-list-item .resource-list-details[data-v-6d9f3f05]{flex-basis:100%;width:100%}li.collection-list-item .resource-list-details li[data-v-6d9f3f05]{display:flex;margin-left:44px;border-radius:3px;cursor:pointer}li.collection-list-item .resource-list-details li[data-v-6d9f3f05]:hover{background-color:var(--color-background-dark)}li.collection-list-item .resource-list-details li a[data-v-6d9f3f05]{flex-grow:1;padding:3px;max-width:calc(100% - 30px);display:flex}li.collection-list-item .resource-list-details span[data-v-6d9f3f05]{display:inline-block;vertical-align:top;margin-right:10px}li.collection-list-item .resource-list-details span.resource-name[data-v-6d9f3f05]{text-overflow:ellipsis;overflow:hidden;position:relative;vertical-align:top;white-space:nowrap;flex-grow:1;padding:4px}li.collection-list-item .resource-list-details img[data-v-6d9f3f05]{width:24px;height:24px}li.collection-list-item .resource-list-details .icon-close[data-v-6d9f3f05]{opacity:.7}li.collection-list-item .resource-list-details .icon-close[data-v-6d9f3f05]:hover,li.collection-list-item .resource-list-details .icon-close[data-v-6d9f3f05]:focus{opacity:1}.shouldshake[data-v-6d9f3f05]{animation:shake-6d9f3f05 .6s 1 linear}@keyframes shake-6d9f3f05{0%{transform:translate(15px)}20%{transform:translate(-15px)}40%{transform:translate(7px)}60%{transform:translate(-7px)}80%{transform:translate(3px)}to{transform:translate(0)}}.collection-list *[data-v-14902e5b]{box-sizing:border-box}.collection-list>li[data-v-14902e5b]{display:flex;align-items:start}.collection-list>li>.avatar[data-v-14902e5b]{margin-top:5px}#collection-select-container[data-v-14902e5b]{display:flex;flex-direction:column;margin-top:-5px}.multiselect[data-v-14902e5b]{z-index:2;width:100%;margin-left:3px;background-color:transparent}.multiselect[data-v-14902e5b]:not(.multiselect--active) .multiselect__tags{border:none!important}.multiselect[data-v-14902e5b]:not(.multiselect--active) .multiselect__tags input::placeholder{color:var(--color-main-text)}.multiselect[data-v-14902e5b] .multiselect__input{background-color:transparent}.multiselect span.avatar[data-v-14902e5b]{display:block;padding:16px;opacity:.7;background-repeat:no-repeat;background-position:center}.multiselect span.avatar[data-v-14902e5b]:hover{opacity:1}.multiselect.multiselect--active+p.hint[data-v-14902e5b]{opacity:0}p.hint[data-v-14902e5b]{z-index:1;margin-top:-16px;padding:8px;color:var(--color-text-maxcontrast);line-height:normal}div.avatar[data-v-14902e5b]{width:32px;height:32px;margin:30px 0 0;padding:8px;background-color:var(--color-background-dark)}.icon-projects[data-v-14902e5b]{display:block;padding:8px;background-repeat:no-repeat;background-position:center}.option__wrapper[data-v-14902e5b]{display:flex}.option__wrapper .avatar[data-v-14902e5b]{display:block;background-color:var(--color-background-darker)!important}.option__wrapper .option__title[data-v-14902e5b]{padding:4px}.fade-enter-active[data-v-14902e5b],.fade-leave-active[data-v-14902e5b]{transition:opacity .5s}.fade-enter[data-v-14902e5b],.fade-leave-to[data-v-14902e5b]{opacity:0}")),document.head.appendChild(t)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import R, { set as X } from "vue";
import { NcAvatar as F, NcActions as z, NcActionButton as q, NcMultiselect as J } from "@nextcloud/vue";
import K from "@nextcloud/axios";
import { generateOcsUrl as C } from "@nextcloud/router";
function k(n) {
  var e = typeof n;
  return n != null && (e == "object" || e == "function");
}
var Q = typeof global == "object" && global && global.Object === Object && global;
const Y = Q;
var Z = typeof self == "object" && self && self.Object === Object && self, ee = Y || Z || Function("return this")();
const M = ee;
var te = function() {
  return M.Date.now();
};
const j = te;
var ne = /\s/;
function oe(n) {
  for (var e = n.length; e-- && ne.test(n.charAt(e)); )
    ;
  return e;
}
var re = /^\s+/;
function ie(n) {
  return n && n.slice(0, oe(n) + 1).replace(re, "");
}
var se = M.Symbol;
const N = se;
var P = Object.prototype, le = P.hasOwnProperty, ce = P.toString, T = N ? N.toStringTag : void 0;
function ae(n) {
  var e = le.call(n, T), o = n[T];
  try {
    n[T] = void 0;
    var r = !0;
  } catch {
  }
  var i = ce.call(n);
  return r && (e ? n[T] = o : delete n[T]), i;
}
var ue = Object.prototype, de = ue.toString;
function fe(n) {
  return de.call(n);
}
var pe = "[object Null]", he = "[object Undefined]", L = N ? N.toStringTag : void 0;
function me(n) {
  return n == null ? n === void 0 ? he : pe : L && L in Object(n) ? ae(n) : fe(n);
}
function _e(n) {
  return n != null && typeof n == "object";
}
var Ce = "[object Symbol]";
function ve(n) {
  return typeof n == "symbol" || _e(n) && me(n) == Ce;
}
var x = 0 / 0, ye = /^[-+]0x[0-9a-f]+$/i, ge = /^0b[01]+$/i, be = /^0o[0-7]+$/i, Te = parseInt;
function B(n) {
  if (typeof n == "number")
    return n;
  if (ve(n))
    return x;
  if (k(n)) {
    var e = typeof n.valueOf == "function" ? n.valueOf() : n;
    n = k(e) ? e + "" : e;
  }
  if (typeof n != "string")
    return n === 0 ? n : +n;
  n = ie(n);
  var o = ge.test(n);
  return o || be.test(n) ? Te(n.slice(2), o ? 2 : 8) : ye.test(n) ? x : +n;
}
var Ie = "Expected a function", Oe = Math.max, we = Math.min;
function Re(n, e, o) {
  var r, i, d, p, c, s, a = 0, I = !1, h = !1, u = !0;
  if (typeof n != "function")
    throw new TypeError(Ie);
  e = B(e) || 0, k(o) && (I = !!o.leading, h = "maxWait" in o, d = h ? Oe(B(o.maxWait) || 0, e) : d, u = "trailing" in o ? !!o.trailing : u);
  function g(l) {
    var m = r, b = i;
    return r = i = void 0, a = l, p = n.apply(b, m), p;
  }
  function O(l) {
    return a = l, c = setTimeout(w, e), I ? g(l) : p;
  }
  function H(l) {
    var m = l - s, b = l - a, A = e - m;
    return h ? we(A, d - b) : A;
  }
  function $(l) {
    var m = l - s, b = l - a;
    return s === void 0 || m >= e || m < 0 || h && b >= d;
  }
  function w() {
    var l = j();
    if ($(l))
      return E(l);
    c = setTimeout(w, H(l));
  }
  function E(l) {
    return c = void 0, u && r ? g(l) : (r = i = void 0, p);
  }
  function V() {
    c !== void 0 && clearTimeout(c), a = 0, r = s = i = c = void 0;
  }
  function G() {
    return c === void 0 ? p : E(j());
  }
  function S() {
    var l = j(), m = $(l);
    if (r = arguments, i = this, s = l, m) {
      if (c === void 0)
        return O(s);
      if (h)
        return clearTimeout(c), c = setTimeout(w, e), g(s);
    }
    return c === void 0 && (c = setTimeout(w, e)), p;
  }
  return S.cancel = V, S.flush = G, S;
}
/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Ne {
  constructor() {
    this.http = K;
  }
  listCollection(e) {
    return this.http.get(C("collaboration/resources/collections/{collectionId}", { collectionId: e }));
  }
  renameCollection(e, o) {
    return this.http.put(C("collaboration/resources/collections/{collectionId}", { collectionId: e }), {
      collectionName: o
    }).then((r) => r.data.ocs.data);
  }
  getCollectionsByResource(e, o) {
    return this.http.get(C("collaboration/resources/{resourceType}/{resourceId}", { resourceType: e, resourceId: o })).then((r) => r.data.ocs.data);
  }
  createCollection(e, o, r) {
    return this.http.post(C("collaboration/resources/{resourceType}/{resourceId}", { resourceType: e, resourceId: o }), {
      name: r
    }).then((i) => i.data.ocs.data);
  }
  addResource(e, o, r) {
    return r = "" + r, this.http.post(C("collaboration/resources/collections/{collectionId}", { collectionId: e }), {
      resourceType: o,
      resourceId: r
    }).then((i) => i.data.ocs.data);
  }
  removeResource(e, o, r) {
    return this.http.delete(C("collaboration/resources/collections/{collectionId}", { collectionId: e }), { params: { resourceType: o, resourceId: r } }).then((i) => i.data.ocs.data);
  }
  search(e) {
    return this.http.get(C("collaboration/resources/collections/search/{query}", { query: e })).then((o) => o.data.ocs.data);
  }
}
const v = new Ne();
/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const _ = R.observable({
  collections: []
}), y = {
  addCollections(n) {
    R.set(_, "collections", n);
  },
  addCollection(n) {
    _.collections.push(n);
  },
  removeCollection(n) {
    R.set(_, "collections", _.collections.filter((e) => e.id !== n));
  },
  updateCollection(n) {
    const e = _.collections.findIndex((o) => o.id === n.id);
    e !== -1 ? R.set(_.collections, e, n) : _.collections.push(n);
  }
}, f = {
  fetchCollectionsByResource({ resourceType: n, resourceId: e }) {
    return v.getCollectionsByResource(n, e).then((o) => (y.addCollections(o), o));
  },
  createCollection({ baseResourceType: n, baseResourceId: e, resourceType: o, resourceId: r, name: i }) {
    return v.createCollection(n, e, i).then((d) => {
      y.addCollection(d), f.addResourceToCollection({
        collectionId: d.id,
        resourceType: o,
        resourceId: r
      });
    });
  },
  renameCollection({ collectionId: n, name: e }) {
    return v.renameCollection(n, e).then((o) => (y.updateCollection(o), o));
  },
  addResourceToCollection({ collectionId: n, resourceType: e, resourceId: o }) {
    return v.addResource(n, e, o).then((r) => (y.updateCollection(r), r));
  },
  removeResource({ collectionId: n, resourceType: e, resourceId: o }) {
    return v.removeResource(n, e, o).then((r) => {
      r.resources.length > 0 ? y.updateCollection(r) : y.removeCollection(r);
    });
  },
  search(n) {
    return v.search(n);
  }
};
function W(n, e, o, r, i, d, p, c) {
  var s = typeof n == "function" ? n.options : n;
  e && (s.render = e, s.staticRenderFns = o, s._compiled = !0), r && (s.functional = !0), d && (s._scopeId = "data-v-" + d);
  var a;
  if (p ? (a = function(u) {
    u = u || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !u && typeof __VUE_SSR_CONTEXT__ < "u" && (u = __VUE_SSR_CONTEXT__), i && i.call(this, u), u && u._registeredComponents && u._registeredComponents.add(p);
  }, s._ssrRegister = a) : i && (a = c ? function() {
    i.call(
      this,
      (s.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), a)
    if (s.functional) {
      s._injectStyles = a;
      var I = s.render;
      s.render = function(g, O) {
        return a.call(O), I(g, O);
      };
    } else {
      var h = s.beforeCreate;
      s.beforeCreate = h ? [].concat(h, a) : [a];
    }
  return {
    exports: n,
    options: s
  };
}
const Se = {
  name: "CollectionListItem",
  components: {
    NcAvatar: F,
    NcActions: z,
    NcActionButton: q
  },
  props: {
    collection: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      detailsOpen: !1,
      newName: null,
      error: {}
    };
  },
  computed: {
    getIcon() {
      return (n) => [n.iconClass];
    },
    typeClass() {
      return (n) => "resource-type-" + n.type;
    },
    limitedResources() {
      return (n) => n.resources ? n.resources.slice(0, 2) : [];
    },
    iconUrl() {
      return (n) => n.mimetype ? OC.MimeType.getIconUrl(n.mimetype) : n.iconUrl ? n.iconUrl : "";
    }
  },
  methods: {
    toggleDetails() {
      this.detailsOpen = !this.detailsOpen;
    },
    showDetails() {
      this.detailsOpen = !0;
    },
    hideDetails() {
      this.detailsOpen = !1;
    },
    removeResource(n, e) {
      f.removeResource({
        collectionId: n.id,
        resourceType: e.type,
        resourceId: e.id
      });
    },
    openRename() {
      this.newName = this.collection.name;
    },
    renameCollection() {
      if (this.newName === "") {
        this.newName = null;
        return;
      }
      f.renameCollection({
        collectionId: this.collection.id,
        name: this.newName
      }).then((n) => {
        this.newName = null;
      }).catch((n) => {
        this.$set(this.error, "rename", t("core", "Failed to rename the project")), console.error(n), setTimeout(() => {
          X(this.error, "rename", null);
        }, 3e3);
      });
    }
  }
};
var je = function() {
  var e = this, o = e._self._c;
  return o("li", { staticClass: "collection-list-item" }, [o("NcAvatar", { staticClass: "collection-avatar", attrs: { "display-name": e.collection.name, "allow-placeholder": !0 } }), e.newName === null ? o("span", { staticClass: "collection-item-name", attrs: { title: "" }, on: { click: e.showDetails } }, [e._v(e._s(e.collection.name))]) : o("form", { class: { shouldshake: e.error.rename }, on: { submit: function(r) {
    return r.preventDefault(), e.renameCollection.apply(null, arguments);
  } } }, [o("input", { directives: [{ name: "model", rawName: "v-model", value: e.newName, expression: "newName" }], attrs: { type: "text", autocomplete: "off", autocapitalize: "off" }, domProps: { value: e.newName }, on: { input: function(r) {
    r.target.composing || (e.newName = r.target.value);
  } } }), o("input", { staticClass: "icon-confirm", attrs: { type: "submit", value: "" } })]), !e.detailsOpen && e.newName === null ? o("div", { staticClass: "linked-icons" }, e._l(e.limitedResources(e.collection), function(r) {
    return o("a", { key: r.type + "|" + r.id, class: e.typeClass(r), attrs: { title: r.name, href: r.link } }, [o("img", { attrs: { src: e.iconUrl(r) } })]);
  }), 0) : e._e(), e.newName === null ? o("span", { staticClass: "sharingOptionsGroup" }, [o("NcActions", [o("NcActionButton", { attrs: { icon: "icon-info" }, on: { click: function(r) {
    return r.preventDefault(), e.toggleDetails.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.detailsOpen ? e.t("core", "Hide details") : e.t("core", "Show details")) + " ")]), o("NcActionButton", { attrs: { icon: "icon-rename" }, on: { click: function(r) {
    return r.preventDefault(), e.openRename.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.t("core", "Rename project")) + " ")])], 1)], 1) : e._e(), o("transition", { attrs: { name: "fade" } }, [e.error.rename ? o("div", { staticClass: "error" }, [e._v(" " + e._s(e.error.rename) + " ")]) : e._e()]), o("transition", { attrs: { name: "fade" } }, [e.detailsOpen ? o("ul", { staticClass: "resource-list-details" }, e._l(e.collection.resources, function(r) {
    return o("li", { key: r.type + "|" + r.id, class: e.typeClass(r) }, [o("a", { attrs: { href: r.link } }, [o("img", { attrs: { src: e.iconUrl(r) } }), o("span", { staticClass: "resource-name" }, [e._v(e._s(r.name || ""))])]), o("span", { staticClass: "icon-close", on: { click: function(i) {
      return e.removeResource(e.collection, r);
    } } })]);
  }), 0) : e._e()])], 1);
}, ke = [], $e = /* @__PURE__ */ W(
  Se,
  je,
  ke,
  !1,
  null,
  "6d9f3f05",
  null,
  null
);
const Ee = $e.exports;
const D = 0, U = 1, Ae = 2, Le = Re(
  function(n) {
    n !== "" && f.search(n).then((e) => {
      this.searchCollections = e;
    }).catch((e) => {
      console.error("Failed to search for collections", e);
    });
  },
  500,
  {}
), xe = {
  name: "CollectionList",
  components: {
    CollectionListItem: Ee,
    NcAvatar: F,
    NcMultiselect: J
  },
  props: {
    /**
     * Resource type identifier
     */
    type: {
      type: String,
      default: null
    },
    /**
     * Unique id of the resource
     */
    id: {
      type: String,
      default: null
    },
    /**
     * Name of the resource
     */
    name: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      selectIsOpen: !1,
      generatingCodes: !1,
      codes: void 0,
      value: null,
      model: {},
      searchCollections: [],
      error: null,
      state: _
    };
  },
  computed: {
    collections() {
      return this.state.collections.filter((n) => typeof n.resources.find((e) => e && e.id === "" + this.id && e.type === this.type) < "u");
    },
    placeholder() {
      return t("core", "Add to a project");
    },
    options() {
      const n = [];
      window.OCP.Collaboration.getTypes().sort().forEach((e) => {
        n.push({
          method: D,
          type: e,
          title: window.OCP.Collaboration.getLabel(e),
          class: window.OCP.Collaboration.getIcon(e),
          action: () => window.OCP.Collaboration.trigger(e)
        });
      });
      for (const e in this.searchCollections)
        this.collections.findIndex((o) => o.id === this.searchCollections[e].id) === -1 && n.push({
          method: U,
          title: this.searchCollections[e].name,
          collectionId: this.searchCollections[e].id
        });
      return this.searchCollections.length === 0 && n.push({
        method: Ae,
        title: t("core", "Type to search for existing projects")
      }), n;
    }
  },
  watch: {
    type() {
      this.isActive && f.fetchCollectionsByResource({
        resourceType: this.type,
        resourceId: this.id
      });
    },
    id() {
      this.isActive && f.fetchCollectionsByResource({
        resourceType: this.type,
        resourceId: this.id
      });
    },
    isActive(n) {
      n && f.fetchCollectionsByResource({
        resourceType: this.type,
        resourceId: this.id
      });
    }
  },
  mounted() {
    f.fetchCollectionsByResource({
      resourceType: this.type,
      resourceId: this.id
    });
  },
  methods: {
    select(n, e) {
      n.method === D && n.action().then((o) => {
        f.createCollection({
          baseResourceType: this.type,
          baseResourceId: this.id,
          resourceType: n.type,
          resourceId: o,
          name: this.name
        }).catch((r) => {
          this.setError(t("core", "Failed to create a project"), r);
        });
      }).catch((o) => {
        console.error("No resource selected", o);
      }), n.method === U && f.addResourceToCollection({
        collectionId: n.collectionId,
        resourceType: this.type,
        resourceId: this.id
      }).catch((o) => {
        this.setError(t("core", "Failed to add the item to the project"), o);
      });
    },
    search(n) {
      Le.bind(this)(n);
    },
    showSelect() {
      this.selectIsOpen = !0, this.$refs.select.$el.focus();
    },
    hideSelect() {
      this.selectIsOpen = !1;
    },
    isVueComponent(n) {
      return n._isVue;
    },
    setError(n, e) {
      console.error(n, e), this.error = n, setTimeout(() => {
        this.error = null;
      }, 5e3);
    }
  }
};
var Be = function() {
  var e = this, o = e._self._c;
  return e.collections && e.type && e.id ? o("ul", { staticClass: "collection-list", attrs: { id: "collection-list" } }, [o("li", { on: { click: e.showSelect } }, [e._m(0), o("div", { attrs: { id: "collection-select-container" } }, [o("NcMultiselect", { ref: "select", attrs: { options: e.options, placeholder: e.placeholder, "tag-placeholder": "Create a new project", label: "title", "track-by": "title", "reset-after": !0, limit: 5 }, on: { select: e.select, "search-change": e.search }, scopedSlots: e._u([{ key: "singleLabel", fn: function(r) {
    return [o("span", { staticClass: "option__desc" }, [o("span", { staticClass: "option__title" }, [e._v(e._s(r.option.title))])])];
  } }, { key: "option", fn: function(r) {
    return [o("span", { staticClass: "option__wrapper" }, [r.option.class ? o("span", { staticClass: "avatar", class: r.option.class }) : r.option.method !== 2 ? o("NcAvatar", { attrs: { "display-name": r.option.title, "allow-placeholder": !0 } }) : e._e(), o("span", { staticClass: "option__title" }, [e._v(e._s(r.option.title))])], 1)];
  } }], null, !1, 3858171110), model: { value: e.value, callback: function(r) {
    e.value = r;
  }, expression: "value" } }, [o("p", { staticClass: "hint" }, [e._v(" " + e._s(e.t("core", "Connect items to a project to make them easier to find")) + " ")])])], 1)]), o("transition", { attrs: { name: "fade" } }, [e.error ? o("li", { staticClass: "error" }, [e._v(" " + e._s(e.error) + " ")]) : e._e()]), e._l(e.collections, function(r) {
    return o("CollectionListItem", { key: r.id, attrs: { collection: r } });
  })], 2) : e._e();
}, De = [function() {
  var n = this, e = n._self._c;
  return e("div", { staticClass: "avatar" }, [e("span", { staticClass: "icon-projects" })]);
}], Ue = /* @__PURE__ */ W(
  xe,
  Be,
  De,
  !1,
  null,
  "14902e5b",
  null,
  null
);
const He = Ue.exports;
export {
  He as CollectionList,
  Ee as CollectionListItem
};
//# sourceMappingURL=index.mjs.map
